import { render, staticRenderFns } from "./OrderAdminView.vue?vue&type=template&id=6fde3322&scoped=true&"
import script from "./OrderAdminView.vue?vue&type=script&lang=js&"
export * from "./OrderAdminView.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdminView.vue?vue&type=style&index=0&id=6fde3322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde3322",
  null
  
)

export default component.exports